import Phaser from "phaser";
import { ArrowBtn } from "@phaser/ui/btns/ArrowBtn";

interface RightBtnOptions {
  textureKey: string;
  onClick: () => void;
}

export class RightBtn extends ArrowBtn {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: RightBtnOptions,
  ) {
    super(scene, x, y, {
      textureKey: options.textureKey,
      direction: "RIGHT",
      onClick: options.onClick,
    });
  }
}
